import React from 'react';
import clsx from 'clsx';
import {
  Box,
  Card as MuiCard,
  CardHeader,
  Divider
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ErrorBoundary from './ErrorBoundary';


const useStyles = makeStyles((theme) => ({
  clickable: {
    cursor: 'pointer',
    '&:hover': {
      transform: 'scale(1.05)',
    },
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
  },
  box: {
    display: 'flex',
    flex: '1 1',
  }
}));

function Card({
  title,
  children,
  onClick,
  footer,
  action,
  p,
  m,
  ml,
  mr,
  mb,
  mt,
  boxProps,
  ...cardProps
}: any) {
  const classes = useStyles();
  return (
    <MuiCard
      {...cardProps}
      className={clsx(cardProps.className, {
        [classes.clickable]: Boolean(onClick),
      })}
      onClick={onClick}
    >
      <ErrorBoundary>
        {
          title && (
            <>
              <CardHeader title={title} action={action} />
              <Divider />
            </>
          )
        }
        <Box
          p={p === undefined ? 3 : p}
          {...boxProps}
          className={clsx(classes.box, boxProps ? boxProps.className : null)}
        >
          {children}
        </Box>
        {
          footer && (
            <>
              <Divider />
              {footer}
            </>
          )
        }
      </ErrorBoundary>
    </MuiCard>
  );
}

export default Card;
